import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FinancialPosition} from "../../models/financial-position";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../auth/services/auth.service";
import {FinancialPositionService} from "../../services/financial-position.service";
import {HeaderService} from "../../../tandem-core/services/header.service";
import {ProposedChange} from "../../models/proposed-change";
import {DialogService, TandemDialogConfig} from "../../../tandem-core/services/dialog.service";
import {TandemUser} from "../../../auth/models/tandem-user";
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {CreateGoalFromPcFormComponent} from "../create-goal-from-pc-form/create-goal-from-pc-form.component";
import {UserService} from "../../../auth/user.service";
import {Subject, Subscription, takeUntil} from "rxjs";
import {Asset} from "../../models/asset";
import {Liability} from "../../models/liability";
import { TandemDatePipe } from 'src/app/modules/tandem-core/directives/tandem-date.pipe';
import {Chat, CommentPanelComponent} from "../../../tandem-core/components/chat/comment-panel/comment-panel.component";
import {Timestamp} from "firebase/firestore";
import {AssetCategory} from "../../models/asset-category";
import {LiabilityCategory} from "../../models/liability-category";
import {NotificationType} from "../../../tandem-core/models/tandem-notification";
import {NotificationService} from "../../../tandem-core/services/notification.service";

@Component({
  selector: 'tandem-view-financial-position',
  templateUrl: './view-financial-position.component.html',
  styleUrls: ['./view-financial-position.component.scss']
})
export class ViewFinancialPositionComponent implements OnInit, OnDestroy {

  userId: string | undefined;
  financialPositionId: string | null = null;
  financialPosition: FinancialPosition | undefined;

  selectedMode: 'view' | 'proposeChanges' = 'view';

  coachReview: boolean = false;
  reviewedUserId: string | null = null;

  user: TandemUser | null = null;
  actionItemsForm: FormGroup = this.fb.group({actionItems: [null]})

  currentlyProposedChanges: ProposedChange[] = [];
  private reviewedUser?: TandemUser;

  private eventSubscription?: Subscription;

  @ViewChild('buttons', {static: false})
  public buttons?: TemplateRef<any>;

  showActionDropdown = false;


  constructor(private route: ActivatedRoute,
              private fb: FormBuilder,
              private router: Router,
              private auth: AuthService,
              private userService: UserService,
              private financialPositionService: FinancialPositionService,
              private datePipe: TandemDatePipe,
              private headerService: HeaderService,
              private notificationService: NotificationService,
              private dialog: DialogService) {
    this.financialPositionId = this.route.snapshot.paramMap.get('id');
    this.reviewedUserId = this.route.snapshot.paramMap.get('userId');
    this.coachReview = router.url.includes('user-management');
  }
  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    this.eventSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.auth.$user.pipe(takeUntil(this.destroy$)).subscribe(user => {
      if (this.reviewedUserId) {
        this.userService.get(this.reviewedUserId).subscribe(revUser => {
          this.reviewedUser = revUser
          this.headerService.setConfig({breadcrumbs: [
              {label: 'User Management', route: '/coaching/user-management'},
              {label: this.reviewedUser?.displayName || '', route: `/coaching/user-management/${this.reviewedUserId}`},
              {
                label: `${this.getTrackingToolName('plural')}`,
              }
            ], hideHeader: true})
          // this.headerService.setConfig({
          //   title: `${this.getTrackingToolName('plural')} - ${this.financialPosition?.title}${this.coachReview ? ' - Review' : ''}`,
          //   // subtitle: this.getTrackingToolDescription(),
          //   breadcrumbs: [
          //     {label: 'User Management', route: '/coaching/user-management'},
          //     {label: this.reviewedUser?.displayName || '', route: `/coaching/user-management/${this.reviewedUserId}`},
          //     {
          //       label: `${this.getTrackingToolName('plural')}`,
          //     }
          //   ],
          //   optionalTemplate: this.buttons
          // })
        });
      }
      this.user = user;
      this.userId = user?.id;
      if (user && this.financialPositionId) {
        this.financialPositionService.get(this.financialPositionId).subscribe(fp => {
          this.financialPosition = fp;
          // this.headerService.setTitle(`${this.getTrackingToolName('plural')}${this.coachReview ? ' - Review' : ''}`);
          // this.headerService.setTitleRow2(this.datePipe.transform(this.financialPosition.positionDate.toDate()));
          // this.headerService.setSubtitle(this.getTrackingToolDescription());
          if (!this.reviewedUserId) {
            this.headerService.setBreadcrumbs([
              {
                label: `${this.getTrackingToolName('plural')}`,
                route: 'financial-positions'
              },
              {
                label: `${this.financialPosition?.title.replace(`${this.getTrackingToolName('single')} as of `, '')}`,
                route: `financial-positions/${this.financialPositionId}`
              }
            ]);
            this.headerService.setHideHeader(true);
          //   this.headerService.setTemplateRef(this.buttons!)
          }
          this.currentlyProposedChanges = this.getProposedChangesForFP();
          if (this.currentlyProposedChanges) {
            this.actionItemsForm = this.fb.group({
              actionItems: this.fb.array(this.getProposedChangesForFP().map(change => this.fb.control(change.completed)))
            });
          } else {
            this.actionItemsForm.get('actionItems')?.setValue(null);
          }

          if (this.dialog.getPanelComponent()?.instance['chatType'] === 'financial-position') {
            this.dialog.updateComponentData({chats: this.financialPosition.comments ? [...this.financialPosition.comments] : []});
          } else if (this.dialog.getPanelComponent()?.instance['chatType'] === 'asset') {
            const asset = this.financialPosition.assets
              .find(category => category.name ===
                this.dialog.getPanelComponent()?.instance['assetCategory']?.name)?.assets
              .find(asset => asset.name === this.dialog.getPanelComponent()?.instance['asset']?.name);
            this.dialog.updateComponentData({chats: asset?.comments ? asset.comments : []});
          } else if (this.dialog.getPanelComponent()?.instance['chatType'] === 'liability') {
            const liability = this.financialPosition.liabilities
              .find(category => category.name ===
                this.dialog.getPanelComponent()?.instance['liabilityCategory']?.name)?.liabilities
              .find(liability => liability.name === this.dialog.getPanelComponent()?.instance['liability']?.name);
            this.dialog.updateComponentData({chats: liability?.comments ? liability.comments : []});
          }
        })
      }
    });

    this.eventSubscription = this.dialog.componentEvents$.subscribe(
      event => this.handleChatEvent(event)
    );
  }

  public setMode(mode: 'view' | 'proposeChanges'): void {
    this.selectedMode = mode;
  }

  onDelete() {
    this.dialog.openConfirmDialog(`Delete ${this.getTrackingToolName('single')}`, `Are you sure you want to delete this ${this.getTrackingToolName('single')}? This action cannot be undone`).afterClosed().subscribe(res => {
      if (res) {
        this.financialPositionService.delete(this.financialPositionId!).then(res => {
          this.router.navigate(['financial-positions']);
        })
      }
    })
  }
  onEdit() {
    this.router.navigate([`financial-positions/${this.financialPositionId}/edit`]);
  }

  onComment() {
    const chatData = {
      chats: this.financialPosition?.comments ? this.financialPosition.comments : [],
      chatType: 'financial-position',
      financialPosition: this.financialPosition,
      reviewedUserId: this.reviewedUserId
    };
    this.dialog.openSidePanel(CommentPanelComponent, chatData);
  }

  public routeBack(): void {
    if (this.coachReview) {
      this.router.navigate([`/coaching/user-management/${this.reviewedUserId}`], {queryParams: {tab: 'financialPositions'}})
    } else {
      this.router.navigate(['/financial-positions']);
    }
  }

  getTrackingToolName(variant: 'single' | 'plural') {
    if (variant === 'single') {
      return this.user?.customTTMetadata?.fpName ? this.user.customTTMetadata.fpName : 'Financial Position';
    } else {
      return this.user?.customTTMetadata?.fpNamePlural ? `${this.user.customTTMetadata.fpNamePlural}` : 'Financial Positions';
    }
  }

  getTrackingToolDescription() {
    return !!this.user?.customTTMetadata?.fpDescription ? this.user.customTTMetadata.fpDescription : 'A summary of what you own, your assets, and what you owe, your liabilities at a given point in time'
  }

  syncGoals() {
    if (this.currentlyProposedChanges) {
      this.dialog.openModal(CreateGoalFromPcFormComponent, {proposedChanges: this.currentlyProposedChanges, userId: this.reviewedUserId ? this.reviewedUserId : this.userId!}).afterClosed().subscribe(res => {
      });
    }
  }

  get actionItems() {
    return this.actionItemsForm.get('actionItems') as FormArray;
  }

  getControl(itemControl: AbstractControl<any>) {
    return itemControl as FormControl;
  }

  onToggle($event: boolean, proposedChange: ProposedChange) {
    proposedChange.completed = !proposedChange.completed;
  }

  onDeleteProposedChange(i: number) {
    let config: TandemDialogConfig = {
      title: 'Delete Proposed Change',
      content: `Are you sure you'd like to delete this proposed change?`,
      type: 'confirm',
      actions: [
        {
          text: 'Cancel',
          role: 'cancel',
          callback: () => {
            this.dialog.closeModal2();
          }
        },
        {
          text: `Yes, I'm sure`,
          role: 'confirm',
          callback: () => {
            this.dialog.closeModal2();
            let sourceItem: Asset | Liability | undefined;
            let destinationItem: Asset | Liability | undefined;
            if (this.financialPosition && this.currentlyProposedChanges) {
              let deletedId: number = this.currentlyProposedChanges[i].id;



              if (this.currentlyProposedChanges[i].sourceType === 'Asset') {
                this.financialPosition.assets.forEach(cat => {
                  cat.assets.forEach(ass => {
                    if (cat.name === this.currentlyProposedChanges[i].sourceCategory && ass.name === this.currentlyProposedChanges[i].sourceItem) {
                      sourceItem = ass;
                    }
                  });
                });
              } else {
                this.financialPosition.liabilities.forEach(cat => {
                  cat.liabilities.forEach(liability => {
                    if (cat.name === this.currentlyProposedChanges[i].sourceCategory && liability.name === this.currentlyProposedChanges[i].sourceItem) {
                      sourceItem = liability;
                    }
                  });
                });
              }

              if (this.currentlyProposedChanges[i].destinationType === 'Asset') {
                this.financialPosition.assets.forEach(cat => {
                  cat.assets.forEach(ass => {
                    if (cat.name === this.currentlyProposedChanges[i].destinationCategory && ass.name === this.currentlyProposedChanges[i].destinationItem) {
                      destinationItem = ass;
                    }
                  });
                });
              } else {
                this.financialPosition.liabilities.forEach(cat => {
                  cat.liabilities.forEach(liability => {
                    if (cat.name === this.currentlyProposedChanges[i].destinationCategory && liability.name === this.currentlyProposedChanges[i].destinationItem) {
                      destinationItem = liability;
                    }
                  });
                });
              }

              if (sourceItem && destinationItem) {

                let sourceEndingBalance = this.getTotalProposedChange(this.currentlyProposedChanges[i].sourceType, sourceItem)
                let destinationEndingBalance = this.getTotalProposedChange(this.currentlyProposedChanges[i].destinationType, destinationItem)

                if (this.currentlyProposedChanges[i].sourceType === 'Asset') {
                  sourceEndingBalance += this.currentlyProposedChanges[i].amount;
                } else {
                  sourceEndingBalance -= this.currentlyProposedChanges[i].amount;
                }

                if (this.currentlyProposedChanges[i].destinationType === 'Asset') {
                  destinationEndingBalance -= this.currentlyProposedChanges[i].amount;
                } else {
                  destinationEndingBalance += this.currentlyProposedChanges[i].amount;
                }


                if (sourceEndingBalance < 0 || destinationEndingBalance < 0) {
                  let followUp: TandemDialogConfig = {
                    title: 'Are You Sure?',
                    content: `By deleting this proposed change, one of your items will have a negative balance. If you continue, you'll probably have to fix it by making some other change.
                    Are you sure this is what you want?`,
                    type: 'confirm',
                    actions: [
                      {
                        text: 'No, cancel',
                        role: 'cancel',
                        callback: () => {
                          this.dialog.closeModal2();
                        }
                      },
                      {
                        text: `Yes, I'm sure`,
                        role: 'confirm',
                        callback: () => {
                          this.financialPosition!.assets.forEach(cat => cat.assets.forEach(asset => asset.proposedChanges = asset.proposedChanges?.filter(pc => pc.id !== deletedId)));
                          this.financialPosition!.liabilities.forEach(cat => cat.liabilities.forEach(liability => liability.proposedChanges = liability.proposedChanges?.filter(pc => pc.id !== deletedId)));
                          this.currentlyProposedChanges = this.getProposedChangesForFP();
                          if (this.currentlyProposedChanges) {
                            this.actionItemsForm = this.fb.group({
                              actionItems: this.fb.array(this.getProposedChangesForFP().map(change => this.fb.control(change.completed)))
                            });
                          } else {
                            this.actionItemsForm.get('actionItems')?.setValue(null);
                          }
                          this.clean(this.financialPosition!);
                          this.financialPositionService.update(this.financialPosition!);
                        }
                      },
                    ]
                  }
                  this.dialog.openModal2(followUp);
                } else {
                  this.financialPosition.assets.forEach(cat => cat.assets.forEach(asset => asset.proposedChanges = asset.proposedChanges?.filter(pc => pc.id !== deletedId)));
                  this.financialPosition.liabilities.forEach(cat => cat.liabilities.forEach(liability => liability.proposedChanges = liability.proposedChanges?.filter(pc => pc.id !== deletedId)));
                  this.currentlyProposedChanges = this.getProposedChangesForFP();
                  if (this.currentlyProposedChanges) {
                    this.actionItemsForm = this.fb.group({
                      actionItems: this.fb.array(this.getProposedChangesForFP().map(change => this.fb.control(change.completed)))
                    });
                  } else {
                    this.actionItemsForm.get('actionItems')?.setValue(null);
                  }
                  this.clean(this.financialPosition);
                  this.financialPositionService.update(this.financialPosition);
                }
              }
            }
          }
        },
      ]
    }
    this.dialog.openModal2(config)
  }

  private getTotalProposedChange(itemType: 'Asset' | 'Liability', item: Asset | Liability): number {
    let totalChange = 0;

    if (itemType === 'Asset') {
      item.proposedChanges?.forEach(change => {
        if (change.sourceItem === item.name) {
          totalChange -= change.amount;
        } else if (change.destinationItem === item.name) {
          totalChange += change.amount;
        }
      })
    } else { // Liability
      item.proposedChanges?.forEach(change => {
        if (change.sourceItem === item.name) {
          totalChange += change.amount;
        } else if (change.destinationItem === item.name) {
          totalChange -= change.amount;
        }
      })
    }
    return item.value + totalChange;
  }

  clean(obj: { [x: string]: any; }) {
    for (const propName in obj) {
      if (obj[propName] === undefined) {
        delete obj[propName]; // Or set to null if you want to keep the field
      } else if (typeof obj[propName] === 'object') {
        this.clean(obj[propName]);
      }
    }
  }

  public getProposedChangesForFP(): ProposedChange[] {
    let proposedChanges: ProposedChange[] = [];
    this.financialPosition?.assets.forEach(cat => {
      cat.assets.forEach(asset => {
        asset.proposedChanges?.forEach(proposedChange => {
          if (!proposedChanges.some(change => change.id === proposedChange.id)) {
            proposedChanges.push(proposedChange);
          }
        });
      });
    });
    this.financialPosition?.liabilities.forEach(cat => {
      cat.liabilities.forEach(liability => {
        liability.proposedChanges?.forEach(proposedChange => {
          if (!proposedChanges.some(change => change.id === proposedChange.id)) {
            proposedChanges.push(proposedChange);
          }
        });
      });
    });
    return proposedChanges;
  }

  handleUpdate() {
    if (this.financialPosition) {
      this.financialPositionService.update(this.financialPosition);
    }
  }

  getMessage(proposedChange: ProposedChange) {
    return this.financialPositionService.getMessage(proposedChange);
  }

  private handleChatEvent(event: any) {
    if (event.type === 'fpMessage' && this.financialPosition) {
      const chat: Chat = {
        message: event.data,
        date: Timestamp.now(),
        status: 'Delivered',
        userId: this.userId || ''
      };

      if (this.financialPosition?.comments) {
        this.financialPosition.comments.push(chat);
        this.financialPosition.comments = [...this.financialPosition.comments]
      } else {
        this.financialPosition.comments = [chat];
      }

      this.financialPositionService.update(this.financialPosition).then(res => {
          let content = `${this.user?.displayName} has commented on ${this.reviewedUser ? 'your ' : 'their '}${this.getTrackingToolName('single')} from ${this.financialPosition?.title}`;


          this.notificationService.add({
            type: NotificationType.MentionInComment,
            date: Timestamp.now(),
            userId: !!this.reviewedUserId ? this.reviewedUserId : this.user?.coachId || 'n/a',
            content: content,
            dateModified: Timestamp.now(),
            dateCreated: Timestamp.now(),
            isRead: false,
            sourcePhotoURL: this.user?.photoURL,
            sourceUserId: this.user?.uid,
            sourceUserName: this.user?.displayName,
            link: !!this.reviewedUser ? `financial-positions/${this.financialPositionId}` : `coaching/user-management/${this.userId}/financial-positions/${this.financialPositionId}`
          })
      }
      )
    }
  }

  handleAssetComment($event: { assetCategory: AssetCategory; asset: Asset; comment: Chat }) {
    if (this.financialPosition) {
      const assetCategory: AssetCategory | null = this.financialPosition.assets.find(cat => cat.name === $event.assetCategory.name) || null;
      if (assetCategory) {
        const asset = assetCategory.assets.find(asset => asset.name === $event.asset.name) || null;
        if (asset) {
          asset.comments = asset.comments ? [...asset.comments, $event.comment] : [$event.comment];
          this.financialPositionService.update(this.financialPosition).then(res => {
            let content = `${this.user?.displayName} has commented on ${asset.name} for ${this.reviewedUser ? 'your ' : 'their '}${this.getTrackingToolName('single')} from ${this.financialPosition?.title}`;

            // Create a route configuration object
            const routeConfig = {
              reviewedUser: !!this.reviewedUser,
              userId: this.userId,
              financialPositionId: this.financialPositionId,
              assetCategory: assetCategory.name,
              asset: asset.name
            };
            // TODO use serializedRoute for link

            // Serialize the route configuration to JSON
            const serializedRoute: string = JSON.stringify(routeConfig);

            this.notificationService.add({
              type: NotificationType.MentionInComment,
              date: Timestamp.now(),
              userId: !!this.reviewedUserId ? this.reviewedUserId : this.user?.coachId || 'n/a',
              content: content,
              dateModified: Timestamp.now(),
              dateCreated: Timestamp.now(),
              isRead: false,
              sourcePhotoURL: this.user?.photoURL,
              sourceUserId: this.user?.uid,
              sourceUserName: this.user?.displayName,
              link: !!this.reviewedUser ? `financial-positions/${this.financialPositionId}` : `coaching/user-management/${this.userId}/financial-positions/${this.financialPositionId}`
            });
          });
        }
      }
    }
  }

  handleLiabilityComment($event: { liabilityCategory: LiabilityCategory; liability: Liability; comment: Chat }) {
    if (this.financialPosition) {
      const liabilityCategory: LiabilityCategory | null = this.financialPosition.liabilities.find(cat => cat.name === $event.liabilityCategory.name) || null;
      if (liabilityCategory) {
        const liability = liabilityCategory.liabilities.find(liability => liability.name === $event.liability.name) || null;
        if (liability) {
          liability.comments = liability.comments ? [...liability.comments, $event.comment] : [$event.comment];
          this.financialPositionService.update(this.financialPosition).then(res => {
            let content = `${this.user?.displayName} has commented on ${liability.name} for ${this.reviewedUser ? 'your ' : 'their '}${this.getTrackingToolName('single')} from ${this.financialPosition?.title}`;

            // Create a route configuration object
            const routeConfig = {
              reviewedUser: !!this.reviewedUser,
              userId: this.userId,
              financialPositionId: this.financialPositionId,
              liabilityCategory: liabilityCategory.name,
              liability: liability.name
            };

            // TODO use serializedRoute for link

            // Serialize the route configuration to JSON
            const serializedRoute: string = JSON.stringify(routeConfig);

            this.notificationService.add({
              type: NotificationType.MentionInComment,
              date: Timestamp.now(),
              userId: !!this.reviewedUserId ? this.reviewedUserId : this.user?.coachId || 'n/a',
              content: content,
              dateModified: Timestamp.now(),
              dateCreated: Timestamp.now(),
              isRead: false,
              sourcePhotoURL: this.user?.photoURL,
              sourceUserId: this.user?.uid,
              sourceUserName: this.user?.displayName,
              link: !!this.reviewedUser ? `financial-positions/${this.financialPositionId}` : `coaching/user-management/${this.userId}/financial-positions/${this.financialPositionId}`
            });
          });
        }
      }
    }
  }
}
